/**
 * Image `context` values that are NOT artwork.
 *
 * `chat` (Arty attachments) and `message` (direct-message attachments) are ordinary
 * `images` rows, distinguished from real artwork only by this column. They must be
 * excluded from every artwork surface - public pages, feeds, the new-work announce and
 * fan-out, engagement, comments, milestone counts, mock generation - or a private
 * screenshot leaks as published work.
 *
 * The list lives here, framework-free, because both sides of the boundary need it: the
 * API re-exports it from `api/src/utils/imageContext.ts` (which adds the SQL and DM
 * helpers), and the two apps read it through `artwork-visibility` and `gallery-picker`.
 * One list, so a third context can never be added to half of them.
 */
export const NON_ARTWORK_CONTEXTS = ['chat', 'message'] as const;

export type NonArtworkContext = (typeof NON_ARTWORK_CONTEXTS)[number];

export function isNonArtworkContext(context: string | null | undefined): boolean {
  return NON_ARTWORK_CONTEXTS.includes(context as NonArtworkContext);
}
